import script from "./LoginComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LoginComponent.vue?vue&type=style&index=0&id=38c57cde&lang=css&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Web.API\\client-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c57cde"]])

export default __exports__